import React from "react";

export function SimpleSelect({ value, onChange, options, disabled, "data-testid": dataTestId }) {
  return (
    <select
      className="border border-slate-300 rounded-full px-3 py-1 text-xs bg-white text-slate-700"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
